// extracted by mini-css-extract-plugin
export default {"item":"item---CF0NQ","content":"content---ibZ2f","creationLabel":"creationLabel---qMFQg"};